import { Link } from "#src/components/Router.tsx";
import Container from "#src/components/layout/Container.tsx";
import { useMediaQueries } from "#src/utils/useMediaQueries.tsx";

export function AdyenAlertBanner() {
  const { small } = useMediaQueries();

  let message =
    "Your bank connection requires urgent attention. Action required immediately to avoid interruption with payments. Click here to clear up any issues. Captyn support is also available to help.";

  if (small) {
    message =
      "Your bank connection requires urgent attention. Action required immediately to avoid interruption with payments.";
  }

  return (
    <Link
      to="/admin/bank"
      className="bg-error relative z-10 flex h-[75px] w-full items-center text-white"
    >
      <Container large>
        <div className="flex items-center gap-4">
          <div>
            <i className="far fa-triangle-exclamation text-3xl text-white" />
          </div>
          <div className="flex-1">{message}</div>
        </div>
      </Container>
    </Link>
  );
}
